/**
 * @generated SignedSource<<169471efe44572332b0d090ea72d5c93>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useNotificationsConfig_notifications$data = {
  readonly listings: number | null;
  readonly messages: number | null;
  readonly orders: number | null;
  readonly recommendations: number | null;
  readonly " $fragmentType": "useNotificationsConfig_notifications";
};
export type useNotificationsConfig_notifications$key = {
  readonly " $data"?: useNotificationsConfig_notifications$data;
  readonly " $fragmentSpreads": FragmentRefs<"useNotificationsConfig_notifications">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useNotificationsConfig_notifications",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "listings",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "orders",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "messages",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "recommendations",
      "storageKey": null
    }
  ],
  "type": "DealerNavBarBadges",
  "abstractKey": null
};

(node as any).hash = "befb655cd19caebef44fb528faad034f";

export default node;
